<template>
    <v-card class="login elevation-12">
        <v-card-title>
            Anmeldeformular
        </v-card-title>
        <v-card-text>
            <v-text-field
                v-model="username"
                name="username"
                autocomplete="username"
                placeholder=" "
                ref="username"
                label="Benutzername"
                type="text"
                autofocus="autofocus"
                :disabled="loading"
            ></v-text-field>
            <v-text-field
                v-model="password"
                name="password"
                autocomplete="password"
                placeholder=" "
                ref="password"
                label="Passwort"
                type="password"
                @keyup.enter="login"
                :disabled="loading"
            ></v-text-field>
            <v-alert :value="error" color="error" icon="mdi-alert-circle" outlined>
                Benutzername oder Passwort falsch.
            </v-alert>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined :loading="loading" :disabled="loading" @click="login">Anmelden</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
import Api from '@/api';
import router from '@/router';

export default {
    name: 'Login',
    data() {
        return {
            loading: false,
            error: false,
            username: '',
            password: '',
        };
    },
    computed: mapState({
        lastPathName: state => state.lastPathName,
    }),
    methods: {
        login() {
            this.loading = true;
            Api.auth.login(this.username, this.password)
                /* eslint-disable-next-line */
                .then(({ data }) => {
                    this.$store.dispatch('loadUserRoles').catch(() => null).finally(() => {
                        this.loading = false;
                        router.push(this.lastPathName);
                    });
                })
                .catch(() => {
                    this.loading = false;
                    this.error = true;
                    this.$nextTick(() => this.$refs.username.focus());
                });
        },
        clear() {
            this.username = '';
            this.password = '';
        },
    },
};
</script>

<style scoped lang="scss"></style>
